import DoctorLeftNav from './DoctorLeftNav.js';

export default DoctorLeftNav;
